module.exports = __webpack_public_path__ + "static/media/image.1270cc4d.png";